module.exports = __webpack_public_path__ + "media/images/emblems/Warth-Weiningen-Blazono-b12668cd9f51c2fcc5cb0cd7640624ad.png";